import { useState } from 'react';

import { ClickableOptionsCard, EditProfileModal } from 'core/Components';
import { Container, Stack, Text, ThemeIcon } from 'ui';
import { IconDelete } from 'ui/Icons';

import { CommunicationListsModalGroup } from '../Account/components/OrgCommunications/CommunicationListsGroup';
import { ChangePasswordModalGroup } from './EditProfile/ChangePasswordGroup';
import { DeleteAccountModal } from './EditProfile/DeleteAccount';
import { ProfileSettingsTemplate } from './components/ProfileSettingsTemplate';

const ProfileContent = () => {
  const [modal, setModal] = useState<'editProfile' | 'deleteAccount' | null>();
  return (
    <ProfileSettingsTemplate title="Profile">
      <Stack gap="xl">
        <Stack>
          <ClickableOptionsCard>
            <ClickableOptionsCard.Row
              title="Edit Profile"
              onClick={() => setModal('editProfile')}
            />
            <ChangePasswordModalGroup />
          </ClickableOptionsCard>
        </Stack>

        <ClickableOptionsCard>
          <CommunicationListsModalGroup />
        </ClickableOptionsCard>

        <ClickableOptionsCard>
          <ClickableOptionsCard.Row
            leftSection={
              <ThemeIcon variant="transparent" c="cerise.7">
                <IconDelete />
              </ThemeIcon>
            }
            title={
              <Text c="cerise.7" fw={500} fz="sm">
                Delete My Givebacks Account
              </Text>
            }
            onClick={() => setModal('deleteAccount')}
          />
        </ClickableOptionsCard>
      </Stack>
      <EditProfileModal opened={modal == 'editProfile'} onClose={() => setModal(null)} />
      <DeleteAccountModal opened={modal == 'deleteAccount'} onClose={() => setModal(null)} />
    </ProfileSettingsTemplate>
  );
};

const Profile = () => {
  return (
    <Container size="xl">
      <ProfileContent />
    </Container>
  );
};

export { Profile as Profile2 };
